"use client";

import { useEffect, useState } from "react";
import { useLazyValue } from "../hooks/useLazyValue";

const preferDarkQuery = "(prefers-color-scheme: dark)";

type ColorScheme = "light" | "dark";

export function useSystemColorScheme() {
  const mediaQuery = useLazyValue(
    () => globalThis.matchMedia?.(preferDarkQuery) ?? "light"
  );

  const [colorScheme, setColorScheme] = useState<ColorScheme>(
    mediaQuery.matches ? "dark" : "light"
  );

  useEffect(() => {
    const listener = ({ matches }: MediaQueryListEvent) => {
      setColorScheme(matches ? "dark" : "light");
    };

    mediaQuery.addEventListener("change", listener);

    return () => {
      mediaQuery.removeEventListener("change", listener);
    };
  }, [mediaQuery]);

  return colorScheme;
}
